<template>
	<div class="content">
		<div class="content-select">
			<el-row :gutter="20">
				<el-col :span="4">
					<div class="select-title">
						<div class="title-img">
							<img src="@/assets/appraisal/select-icon.png" alt="">
						</div>
						<div class="title-info">
							<span>培训机构列表</span>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
		<div class="content-header">
			<myTableSearch :isOperate="true" :operateWidth="230" :formData="formData" :tableLabel="tableLabel"
				:queryFn="queryFn" :queryParams="queryParams" @successQuery="successQuery" :searchColLg="6"
				ref="tableRef" dataRow="rows">
				<template slot="cultivateInstitutionTrainingItemList" slot-scope="scope">
					<span
						v-if="scope.row.cultivateInstitutionTrainingItemList && scope.row.cultivateInstitutionTrainingItemList.length > 0"
						style="white-space: nowrap;">
						<span v-for="(item, index) in scope.row.cultivateInstitutionTrainingItemList" :key="index">
							{{ item.name || '' }}{{ item.level ? '（' + item.level + '）' : '' }}
							<span v-if="index < scope.row.cultivateInstitutionTrainingItemList.length - 1">、</span>
						</span>
					</span>
					<span v-else>-</span>
				</template>
				<template slot="ifSupervisorExamine" slot-scope="scope">
					<span>{{ scope.row.ifSupervisorExamine == 1 ? '是' : '否' }}</span>
				</template>
				<template slot="ifSafetyExamine" slot-scope="scope">
					<span>{{ scope.row.ifSafetyExamine == 1 ? '是' : '否' }}</span>
				</template>
				<template slot="licenseValidDate" slot-scope="scope">
					<span v-if="scope.row.licenseValidStart && scope.row.licenseValidEnd" style="white-space: nowrap;">
						{{ scope.row.licenseValidStart }} 至 {{ scope.row.licenseValidEnd }}
					</span>
					<span v-else-if="scope.row.licenseValidStart" style="white-space: nowrap;">{{
						scope.row.licenseValidStart }}</span>
					<span v-else>-</span>
				</template>
				<template slot="integrityGradeName" slot-scope="scope">
					<img v-if="getIntegrityGradeIcon(scope.row.integrityGradeName)"
						:src="getIntegrityGradeIconSrc(scope.row.integrityGradeName)" style="width: 20px; height: 20px;"
						alt="" />
					<span v-else>-</span>
				</template>
				<template slot="tool">
					<div class="toolbar-container">
						<div class="toolbar-left">
							<div class="tool-btn" @click="handleRefresh" title="刷新">
								<img :src="refreshIcon" alt="刷新" class="toolbar-icon">
							</div>
						</div>
						<div class="toolbar-right">
							<el-button type="primary" icon="el-icon-fake custom-icon icon-organization"
								@click="handleAddAppointment">添加机构</el-button>
							<el-button plain type="info" icon="el-icon-fake custom-icon icon-policy-download"
								:loading="downloadTemplateLoading" @click="handleDownloadTemplate">下载模版</el-button>
							<el-upload ref="uploadRef" action="#" :auto-upload="false" :show-file-list="false"
								:on-change="handleImportFile" accept=".xls,.xlsx" class="import-upload">
								<el-button plain type="info" icon="el-icon-fake custom-icon icon-policy-insert"
									:loading="importLoading">导入</el-button>
							</el-upload>
						</div>
					</div>
				</template>
				<template slot="operate" slot-scope="scope">
					<el-button @click="handleView(scope.row)" size="small" type="text">查看</el-button>
					<el-button @click="handleEdit(scope.row)" size="small" type="text">编辑</el-button>
					<el-button type="text" style="color:rgb(241, 74, 63);" size="small"
						@click="handleDel(scope.row)">删除</el-button>
				</template>
			</myTableSearch>
			<!-- 新增/编辑/查看机构 -->
			<policyDialog v-if="isSubscribeDialog" :isDialog="isSubscribeDialog" :isEdit="isEdit" :isView="isView"
				:editData="editData" @handleClose="isSubscribeDialog = false" @success="handleRefresh">
			</policyDialog>
			<!-- 导入结果 -->
			<importResultDialog v-if="isImportResultDialog" :isDialog="isImportResultDialog"
				:resultData="importResultData" @handleClose="isImportResultDialog = false">
			</importResultDialog>
		</div>
	</div>
</template>

<script>
import '@/assets/css/base.css'
import { getOrganizationList, downloadTemplate, importOrganization, deleteOrganization, getOrganizationDetail } from '@/api/training'
import { getListByDictType } from '@/api/sys/dictData'
import policyDialog from './components/policyDialog.vue'
import importResultDialog from './components/importResultDialog.vue'
import refreshIcon from '@/assets/pages/appointment/refresh.png'

export default {
	name: 'PolicyList',
	components: {
		policyDialog,
		importResultDialog
	},
	data() {
		return {
			refreshIcon,
			currentPage: 1,
			downloadTemplateLoading: false,
			importLoading: false,
			queryParams: {
				pageNum: 1,
				pageSize: 10,
				pageSizes: [10, 20, 50]
			},
			isSubscribeDialog: false,//新增/编辑/查看机构弹窗
			isEdit: false,//是否为编辑模式
			isView: false,//是否为查看模式
			editData: {},//编辑/查看时的数据
			isImportResultDialog: false,//导入结果弹窗
			importResultData: '',//导入结果
			formData: [
				{
					label: '机构名称',
					type: 'input',
					key: 'name',
					colLg: 6,
					placeholder: '机构名称'
				},
				{
					label: '培训项目名称',
					type: 'input',
					key: 'trainingName',
					colLg: 6,
					placeholder: '培训项目名称'
				},
				{
					label: '培训项目等级',
					type: 'input',
					key: 'trainingLevel',
					colLg: 6,
					placeholder: '培训项目等级'
				},
				{
					label: '诚信等级',
					type: 'select',
					key: 'integrityGradeCode',
					colLg: 6,
					data: []
				},
				{
					label: '评估年份',
					type: 'year',
					key: 'assessYear',
					colLg: 6,
					format: 'yyyy'
				},
				{
					label: '核验年份',
					type: 'year',
					key: 'verificationYear',
					colLg: 6,
					format: 'yyyy'
				}
			],
			tableLabel: [
				{
					prop: 'name',
					label: '机构名称',
					minWidth: 150
				},
				{
					prop: 'cultivateInstitutionTrainingItemList',
					label: '培训项目及等级',
					minWidth: 200
				},
				{
					prop: 'contactAddress',
					label: '联系地址',
					minWidth: 200
				},
				{
					prop: 'contactPhone',
					label: '联系电话',
					width: 150
				},
				{
					prop: 'integrityGradeName',
					label: '诚信等级',
					width: 120
				},
				{
					prop: 'assessYear',
					label: '评估年份',
					width: 120
				},
				{
					prop: 'networkVerificationName',
					label: '网络审核',
					width: 120
				},
				{
					prop: 'verificationYear',
					label: '核检年份',
					width: 120
				},
				{
					prop: 'ifSupervisorExamine',
					label: '督导检查',
					width: 100
				},
				{
					prop: 'supervisorQuestion',
					label: '督导问题',
					minWidth: 150
				},
				{
					prop: 'ifSafetyExamine',
					label: '安全检查',
					width: 100
				},
				{
					prop: 'safetyQuestion',
					label: '安全问题',
					minWidth: 150
				},
				{
					prop: 'licenseNumber',
					label: '许可证号',
					minWidth: 150
				},
				{
					prop: 'licenseValidDate',
					label: '许可证有效日期',
					minWidth: 200
				}
			],
		}
	},
	mounted() {
		this.loadIntegrityGradeData()
	},
	methods: {
		// 获取列表数据
		queryFn(queryParams) {
			return getOrganizationList(queryParams)
		},
		// 获取诚信等级字典
		async loadIntegrityGradeData() {
			const res = await getListByDictType('cultivate_institution_integrity_grade')
			if (res && res.code === 200 && res.data) {
				this.updateFormDataWithIntegrityGrade(res.data)
			}
		},
		// 更新诚信等级下拉选项
		updateFormDataWithIntegrityGrade(gradeData) {
			if (!gradeData) return

			const gradeIndex = this.formData.findIndex(item => item.key === 'integrityGradeCode')
			if (gradeIndex !== -1) {
				// 在数据开头添加"全部"选项
				const dataWithAll = [
					{
						dictLabel: '全部',
						dictValue: ''
					},
					...gradeData
				]
				this.$set(this.formData[gradeIndex], 'data', dataWithAll)
			}
		},
		// 上一页
		handlePrevPage() {
			if (this.currentPage > 1) {
				this.currentPage--;
				this.queryParams.pageNum = this.currentPage;
				this.$refs.tableRef && this.$refs.tableRef.handleSearch();
			}
		},
		// 下一页
		handleNextPage() {
			this.currentPage++;
			this.queryParams.pageNum = this.currentPage;
			this.$refs.tableRef && this.$refs.tableRef.handleSearch();
		},
		// 刷新列表
		handleRefresh() {
			this.queryParams.pageNum = 1;
			this.currentPage = 1;
			this.$refs.tableRef && this.$refs.tableRef.handleSearch();
		},
		// 删除
		handleBatchDelete() {
			this.$refs.tableRef && this.$refs.tableRef.deleteAll();
		},
		// 下载导入模板
		handleDownloadTemplate() {
			this.downloadTemplateLoading = true
			downloadTemplate({}).then(res => {
				if (res) {
					this.downloadBlobFile(res, '机构导入模板.xls');
				}
			}).catch(err => {
				console.error('下载失败', err)
				this.$message.error('下载失败')
			}).finally(() => {
				this.downloadTemplateLoading = false
			})
		},
		// 导入文件
		handleImportFile(file) {
			const isExcel = file.raw.type === 'application/vnd.ms-excel' ||
				file.raw.type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
			const isLt10M = file.raw.size / 1024 / 1024 < 10

			if (!isExcel) {
				this.$message.error('只能上传 .xls 或 .xlsx 格式的文件！')
				return
			}
			if (!isLt10M) {
				this.$message.error('文件大小不能超过 10MB！')
				return
			}

			this.importLoading = true
			const formData = new FormData()
			formData.append('file', file.raw)

			importOrganization(formData).then(res => {
				if (res && res.code === 200) {
					this.importResultData = res.data
					this.isImportResultDialog = true
					this.handleRefresh()
				} else {
					this.$message.error(res.msg || '导入失败')
				}
			}).catch(err => {
				console.error('导入出错', err)
				this.$message.error('导入失败')
			}).finally(() => {
				this.importLoading = false
				this.$refs.uploadRef && this.$refs.uploadRef.clearFiles()
			})
		},
		// 新增机构
		handleAddAppointment() {
			this.isEdit = false
			this.isView = false
			this.editData = {}
			this.isSubscribeDialog = true
		},
		// 查看机构
		handleView(row) {
			getOrganizationDetail(row.id).then(res => {
				if (res && res.code === 200) {
					this.editData = res.data
					this.isEdit = false
					this.isView = true
					this.isSubscribeDialog = true
				}
			})

		},
		// 编辑机构
		handleEdit(row) {
			this.isEdit = true
			this.isView = false
			this.editData = { ...row }
			this.isSubscribeDialog = true
		},
		// 删除机构
		handleDel(row) {
			this.$confirm('确定要删除该机构吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				deleteOrganization({ id: row.id }).then(res => {
					if (res && res.code === 200) {
						this.$message.success('删除成功')
						this.handleRefresh()
					} else {
						this.$message.error(res.msg || '删除失败')
					}
				}).catch(err => {
					console.error('删除失败', err)
					this.$message.error('删除失败')
				})
			}).catch(() => { })
		},
		// 更新总数
		successQuery(e) {
			this.syrkNum = e.total;
		},
		// 根据诚信等级名称获取对应的图标文件名
		getIntegrityGradeIcon(gradeName) {
			if (!gradeName) return ''
			const upperName = String(gradeName).toUpperCase()
			if (upperName.includes('A')) {
				return 'rankA'
			} else if (upperName.includes('B')) {
				return 'rankB'
			} else if (upperName.includes('C')) {
				return 'rankC'
			}
			return ''
		},
		// 获取图标路径
		getIntegrityGradeIconSrc(gradeName) {
			const iconName = this.getIntegrityGradeIcon(gradeName)
			if (!iconName) return ''
			return require(`@/assets/images/custom-icons/${iconName}.svg`)
		},
	},
}
</script>

<style lang="scss" scoped>
.content {
	width: 100%;
	height: 100%;
	background: #fff;
	display: flex;
	flex-direction: column;

	&-select {
		height: 50px;

		.select-title {
			height: 46px;
			background: url('~@/assets/appraisal/selectBg.png') no-repeat;
			background-size: 100% 100%;
			display: flex;
			align-items: center;
			gap: 12px;
			padding-left: 16px;

			.title-img {
				width: 18px;
				height: 18px;

				img {
					width: 100%;
					height: 100%;
				}
			}

			.title-info {
				color: var(--vt-c-black-mute-soft);
				font-size: 16px;
				font-weight: 700;
			}
		}

		.select-serch {
			margin-top: 12px;
			display: flex;
			align-items: center;
			gap: 8px;

			.serch-hint {
				color: var(--vt-c-black-mute-soft);
				font-size: 14px;
				font-weight: 400;
			}

			.serch-info {
				height: 28px;
				display: flex;
				align-items: center;
				gap: 12px;

				.info-item {
					width: 120px;
					height: 28px;
					text-align: center;
					line-height: 28px;
					background: var(--vt-c-blue-mute);
					color: var(--vt-c-blue);
					border-radius: 2px;
					cursor: pointer;
					transition: all 0.3s ease;

					&:hover {
						opacity: 0.8;
					}

					&.active {
						background: var(--vt-c-blue);
						color: var(--vt-c-white);
					}

					&:active:not(.active) {
						transform: scale(0.98);
					}
				}
			}
		}
	}

	&-header {
		padding: 0 24px;
		overflow: hidden;
		display: flex;
		flex-direction: column;

		/deep/.myTableSearch {
			padding: 0;
			height: 740px;
			display: flex;
			flex-direction: column;

			/deep/.el-table {
				flex: 1;
				overflow: auto;
			}
		}
	}
}

.link-text {
	color: #409eff;
	text-decoration: none;
	cursor: pointer;

	&:hover {
		text-decoration: underline;
	}
}

.toolbar-container {
	width: 100%;
	display: flex;
	justify-content: space-between;
	align-items: center;
	padding: 8px 0;

	.toolbar-icon {
		width: 24px;
		height: 24px;
	}

	.add-icon {
		width: 20px;
		height: 20px;
		margin-right: 6px;
	}

	.toolbar-left {
		display: flex;
		align-items: center;
		gap: 12px;

		.tool-btn {
			width: 36px;
			height: 36px;
			display: flex;
			align-items: center;
			justify-content: center;
			border: 1px solid #dcdfe6;
			cursor: pointer;
			transition: all 0.2s;
			background-color: #FCFCFCFF;
		}

		.list-title {
			font-size: 14px;
			font-weight: 400;
			color: var(--vt-c-blue-soft);
		}
	}

	.toolbar-right {
		display: flex;
		align-items: center;
		gap: 12px;

		.import-upload {
			display: inline-block;

			/deep/.el-upload {
				display: inline-block;
			}
		}

		.el-button {
			height: 36px;
			padding: 0 16px;
		}
	}
}
</style>